import {
	EMPTY_ADF,
	type FieldValue,
	OTHER_ID,
} from '../../common/types/form/form-fields/field-values';
import {
	asAdfValue,
	asDateTimeValue,
	asDateValue,
	asFilesValue,
	asLocalTimeValue,
	asNumberValue,
	asOptionsValue,
	asTextValue,
} from '../../common/types/form/form-fields/field-values/utils';
import { type FormAnswer, type FormQuestion, FormQuestionType } from '../types/proforma-form';

export const convertFieldValue = (
	fieldValue: FieldValue | undefined,
	formQuestion: FormQuestion,
): FormAnswer => {
	switch (formQuestion.type) {
		case FormQuestionType.ChoiceCascading:
		case FormQuestionType.CmdbObject:
		case FormQuestionType.ChoiceSingle:
		case FormQuestionType.ChoiceMultiple:
		case FormQuestionType.ChoiceDropdown:
		case FormQuestionType.ChoiceDropdownMultiple: {
			const optionsWithOther = asOptionsValue(fieldValue);
			return {
				choices: [
					...(optionsWithOther?.options?.map((option) => option.id) || []),
					...(optionsWithOther?.otherOptionText !== undefined ? [OTHER_ID] : []),
				],
				...(optionsWithOther?.otherOptionText !== undefined
					? { text: optionsWithOther.otherOptionText }
					: {}),
			};
		}
		case FormQuestionType.Date: {
			const dateValue = asDateValue(fieldValue);
			return {
				date: dateValue?.date,
			};
		}
		case FormQuestionType.DateTime: {
			const dateTimeValue = asDateTimeValue(fieldValue);
			return {
				date: dateTimeValue?.date,
				time: dateTimeValue?.localTime,
			};
		}
		case FormQuestionType.Time: {
			const timeValue = asLocalTimeValue(fieldValue);
			return {
				time: timeValue?.localTime,
			};
		}
		case FormQuestionType.Number: {
			const numberValue = asNumberValue(fieldValue);
			return {
				text: numberValue?.number?.toString() || '',
			};
		}
		case FormQuestionType.UserMultiple:
		case FormQuestionType.UserSingle: {
			const userValue = asOptionsValue(fieldValue);
			return {
				users:
					userValue?.options?.map((option) => ({
						name: option.label,
						id: option.id,
					})) || [],
			};
		}
		case FormQuestionType.TextEmail:
		case FormQuestionType.TextLong:
		case FormQuestionType.TextParagraph:
		case FormQuestionType.TextShort:
		case FormQuestionType.TextUrl: {
			const textValue = asTextValue(fieldValue);
			return {
				text: textValue?.text || '',
			};
		}
		case FormQuestionType.RichTextParagraph: {
			const richTextValue = asAdfValue(fieldValue);
			return {
				adf: richTextValue?.adf || EMPTY_ADF,
			};
		}
		case FormQuestionType.Attachment: {
			const filesValue = asFilesValue(fieldValue);
			return {
				files:
					filesValue?.files?.map((file) => ({
						id: file.identifier.id,
						name: file.name,
					})) || [],
			};
		}
		default:
			return {};
	}
};
